import { gradeAdapter } from '@/Module/Grade/Store/Adapter';
import type { IState } from '@/Module/Store/Model';

export const {
  selectById: gradeSelectById,
  selectIds: gradeSelectIds,
  selectAll: gradeSelectAll,
} = gradeAdapter.getSelectors<IState>(state => state.grade);
